import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  getScreens, 
  getLocalization, 
  addLocalization as postLocalization, 
  updateLocalization as putLocalization, 
  deleteLocalization as removeLocalization, 
  UpdateColumnPreference,
  getTableColumnNames,
  addScreens,
  updateScreens,
  deleteScreens
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch localization data
export const fetchCMSLocalization = createAsyncThunk("alitqanCms/fetch", async (localization, thunkAPI) => {
  
  try {
    const response = await getLocalization(localization);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

// Add localization data
export const createCMSLocalization = createAsyncThunk("alitqanCms/add", async (localization, thunkAPI) => {  
  try {
    const response = await postLocalization(localization);

    if (response.success) {
      toast.success(t(response.message));
    }else{
      toast.error(t(response.message));
    }    

    return response;
  } catch (error) {
    toast.error(error.message);
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

// Update localization data
export const updateCMSLocalization = createAsyncThunk("alitqanCms/update", async (localization, thunkAPI) => {
  try {
    const response = await putLocalization(localization);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {
    toast.error(error.message);
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

// Delete localization data
export const deleteCMSLocalization = createAsyncThunk("alitqanCms/delete", async (localization, thunkAPI) => {
  try {
    const response = await removeLocalization(localization);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {
    toast.error(error.message);
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const fetchCMSLocalizationTableColumnNames = createAsyncThunk(
  "alitqanCms/fetchTableColumnNames",
  async (localization, thunkAPI) => {
    try {
      const response = await getTableColumnNames(localization);      
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);
